/* Fabric Alex delivery page v3 — title + local contact refinement. */
(function(){
  'use strict';
  var root=document.querySelector('[data-fa-delivery]');
  if(!root)return;

  var title=root.querySelector('.fa-delivery__hero h1');
  if(title){
    title.textContent=root.getAttribute('data-locale')==='bg'?'Бърза доставка.':'Fast delivery.';
  }

  /* Keep +359 only in the international-delivery information card. The final
     customer-care action displays the familiar Bulgarian local format. */
  var callButton=root.querySelector('.fa-delivery__contact-actions a:first-child');
  if(callButton){
    callButton.setAttribute('href','tel:052920123');
    callButton.textContent=callButton.textContent.replace(/\+359\s*52\s*920\s*123|052\s*920\s*123/g,'052 920 123');
  }
})();
